import React from "react"
import { injectIntl } from "react-intl"
import SideBar from "../common/layout/sidebar.component.jsx"
import OrderTabs from "../common/layout/tabs/orders.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"

const OrderListing = () => {
    SideBar.activateMenu("order")

    return (
        <div>
            <OrderTabs />
            <GenericListing
                objectType={ObjectType.ORDERS}
                selectableRows
            />
        </div>
    )
}

export default injectIntl(OrderListing)



// WEBPACK FOOTER //
// ./src/order/List.tsx